import React, { useMemo } from "react";
import { ISelectOption } from "../../../../components/src/form/SearchMultipleSelectField";

interface FundParseClientSelectorProps {
    clientOptions: ISelectOption[];
    value: string;
    disabled: boolean;
    onChange: (clientId: string) => void;
}

export function FundParseClientSelector({
    clientOptions,
    value,
    disabled,
    onChange
}: FundParseClientSelectorProps): React.ReactElement {
    const clientsAvailable = clientOptions.length > 0;

    const selectOptions = useMemo(() => {
        if (!clientsAvailable) {
            return [{ key: "", label: "No clients available" }];
        }
        return [{ key: "", label: "Select client" }, ...clientOptions.map((option) => ({ key: option.key, label: option.text || option.value }))];
    }, [clientOptions, clientsAvailable]);

    return (
        <div className="mb-4 w-full min-w-0 max-w-xs">
            <label htmlFor="fundparse-client-id" className="mb-1 block text-sm font-medium">
                Client ID
            </label>
            <select
                id="fundparse-client-id"
                className="form-input"
                disabled={disabled || !clientsAvailable}
                value={value}
                onChange={(event) => onChange(event.target.value)}
            >
                {selectOptions.map((option) => (
                    <option key={option.key || "empty"} value={option.key}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    );
}
